import {
  EntityDropdownInputBare,
  type EntityDropdownInputBareProps,
} from "#batteries-included-components/Dropdowns/EntityDropdownInputBare";
import useLocalization from "#src/hooks/useLocalization";
import { DeviceAdapter } from "@validereinc/domain";
import React from "react";

/**
 * Uncontrolled Device dropdown using DropdownInputBare for use in FilterBuilder.
 * Value is controlled by parent (e.g. filter state); does not register with react-hook-form.
 */
export const DeviceDropdownInputBare = (
  props: Omit<EntityDropdownInputBareProps<unknown>, "fetchEntityList">
) => {
  const { localize } = useLocalization();

  return (
    <EntityDropdownInputBare
      fetchEntityList={DeviceAdapter.getList}
      label={props.label ?? localize("Device")}
      sort={{
        sortBy: "name",
        sortDirection: "asc",
      }}
      {...props}
    />
  );
};
